import React from "react";

import { Props } from "./types";
import { Week } from "./week";
import styles from "./styles.scss";

function Navigation({ cursor, week, setCursor }: Props) {
  return (
    <div className={styles.navigation}>
      <Week
        week={week}
        prev={() => setCursor(cursor.minus({ weeks: 1 }))}
        next={() => setCursor(cursor.plus({ weeks: 1 }))}
        editDate={setCursor}
      />
    </div>
  );
}

export { Navigation };
